import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from './ComparisonOfPoliciesRow.module.css';
import HeaderHelmet, { HeaderHelmetProps } from '../../SubSectionHeader/HeaderHelmet';

interface ComparisonOfPoliciesHeaderProps {
  readonly helmet: HeaderHelmetProps;
}

export default function ComparisonOfPoliciesHeader({ helmet }: ComparisonOfPoliciesHeaderProps) {
  const { showBenchmark } = useContext(AppContext);
  const { year } = useContext(AppContext);
  return (
    <>
      <div className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}>
        <HeaderHelmet {...helmet} />
        <h5 aria-hidden="true"></h5>
        <h5 aria-hidden="true"></h5>
        <h5 className="column_align_right">{year} Individual</h5>
        <h5 className="column_align_right">{year} Group</h5>
        <h5 className="column_align_right">{year - 1} Individual</h5>
        <h5 className="column_align_right">{year - 1} Group</h5>
        <h5 className="column_align_right">{year - 2} Individual</h5>
        <h5 className="column_align_right">{year - 2} Group</h5>
      </div>
    </>
  );
}
